export const getEllipsisText = (text: string, index: number, length: number) => {
  const value = text.slice(index, index + length) + (text.length > length ? "..." : "");
  return value;
};
